import React, { useState } from "react";
import { isEmpty } from "lodash";
import { parse } from "json2csv";

const AccountHistory = ({ billingHistory }) => {
  const [currentView, setCurrentView] = useState("history");

  const handleTabClick = (value) => {
    setCurrentView(value);
  };

  const handleExport = () => {
    const data =
      currentView === "history"
        ? billingHistory?.data?.history
        : billingHistory?.data?.billing;
    if (!isEmpty(data)) {
      const csvData = parse(data);
      // Create a Blob containing the CSV data
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      // Create a temporary download link and trigger the download
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute("download", "data.csv");
      document.body.appendChild(link);
      link.click();
      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  return (
    <section className="acc-history">
      <div className="history-flex">
        <p>Account History </p>
        <button className="export" onClick={handleExport}>
          Export
        </button>
      </div>
      <h2 className="heading">View Plan and Billing Activity</h2>
      <p className="info">
        View all activity on your team’s plan. Check your history for plan
        upgrades, added credits, and when teammates are added or removed from
        plan. Check billing for all charges, invoice totals, and collection
        dates.
      </p>
      <p className="view-by">View by activity: </p>
      <div className="activity-buttons">
        {/* <button className="history active">History</button>
        <button className="billing">Billing</button> */}
        <button
          className={`history ${currentView === "history" ? "active" : ""}`}
          onClick={() => handleTabClick("history")}
        >
          History
        </button>
        <button
          className={`billing ${currentView === "billing" ? "active" : ""}`}
          onClick={() => handleTabClick("billing")}
        >
          Billing
        </button>
      </div>
      {currentView === "billing" && (
        <div className="activity-table">
          <div className="activity-table-flex">
            <div className="column">
              <div className="header header1">
                <h2>Type</h2>
              </div>
            </div>
            <div className="column">
              <div className="header header2">
                <h2>Cost</h2>
              </div>
            </div>
            <div className="column quantity">
              <div className="header header3">
                <h2>Quantity</h2>
              </div>
            </div>
            <div className="column">
              <div className="header header4">
                <h2>Total Amount</h2>
              </div>
            </div>
            <div className="column">
              <div className="header header-last">
                <h2>Charge Date</h2>
              </div>
            </div>
          </div>

          {billingHistory?.data?.billing?.map((data, index) => (
            <div className="activity-table-flex" key={index}>
              <div className="column">
                <div className="data data4">
                  <p>{data?.type}</p>
                </div>
              </div>
              <div className="column">
                <div className="data data5">
                  <p>{data?.cost}</p>
                </div>
              </div>
              <div className="column quantity">
                <div className="data data6 ">
                  <p>{data?.quantity}</p>
                </div>
              </div>
              <div className="column">
                <div className="data data7">
                  <p>{data?.total_amount}</p>
                </div>
              </div>
              <div className="column">
                <div className="data data-last">
                  <p>{data?.charge_date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {currentView === "history" && (
        <div
          className={`activity-table ${
            currentView === "history" ? "three-columns-table" : ""
          }`}
        >
          <div className="activity-table-flex">
            <div className="column">
              <div className="header header1">
                <h2>Activity</h2>
              </div>
            </div>
            <div className="column">
              <div className="header header2">
                <h2>Name</h2>
              </div>
            </div>
            <div className="column">
              <div className="header header3">
                <h2>Date</h2>
              </div>
            </div>
          </div>

          {billingHistory?.data?.history?.map((data, index) => (
            <div className="activity-table-flex" key={index}>
              <div className="column">
                <div className="data data2">
                  <p>{data?.activity}</p>
                </div>
              </div>
              <div className="column">
                <div className="data data3">
                  <p>{data?.name}</p>
                </div>
              </div>
              <div className="column">
                <div className="data data4">
                  <p>{data?.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default AccountHistory;
